<template>
  <div :class="classInput">
    <div class="form-group">
      <label class="label" :class="{'required': isRequired}">{{ label }}</label>
      <input
        :value="value"
        v-mask="'(##) #####-####'"
        type="text"
        class="form-control"
        :class="{'is-invalid': isInvalid}"
        :disabled="isDisabled"
        @blur="() => validate()"
        @input="handleInput($event.target.value)"
      >
      <div
        v-if="isInvalid"
        class="invalid-feedback"
      >
        <span v-if="isInvalid">Campo obrigatório.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    typeInput: {
      type: String
    },
    value: {
      type: String
    },
    classInput: {
      type: String,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    forceShowError: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isInvalid: false,
      hasTouched: false
    }
  },
  watch: {
    forceShowError (newVal) {
      if (newVal) {
        this.validate()
      }
    }
  },
  methods: {
    handleInput (value) {
      this.hasTouched = true

      // Se o campo estava com erro e o usuário está digitando, limpar o erro imediatamente
      if (this.isInvalid && value && value !== '') {
        this.isInvalid = false
      }

      this.$emit('input', value)
    },
    validate () {
      const shouldValidate = this.hasTouched || this.forceShowError
      this.isInvalid = shouldValidate && this.isRequired && (!this.value || this.value === '')
    },
    isValid () {
      this.validate()
      return !this.isInvalid
    }
  }
}
</script>
